import { render } from "./RefreshPage.vue?vue&type=template&id=6cb3e9d6"
import script from "./RefreshPage.vue?vue&type=script&lang=js"
export * from "./RefreshPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_ygitl4qwkjirupiphave5nrawa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__